<template>
  <div class="container">
    <section :id="isModeTyping ? 'form-input' : 'duong-so'">
      <h1 class="title">Tử vi</h1>
      <form-input v-if="isModeTyping" @input="setData"/>
      <template v-if="!isModeTyping" >
        <table class="form-change" style="background: white; text-align: left;margin: auto;">
          <tbody>
          <tr>
            <td class="p-3" style="border: 1px solid;width: 40%;">
              <table>
                <tr>
                  <td>Năm xem</td>
                  <td><input v-model="tmpCurYear" @keyup.enter="changeData" placeholder="Nhập năm xem" style="margin-left: 5px; width: 90%"/></td>
                </tr>
                <tr>
                  <td>Năm sinh</td>
                  <td><input v-model="tmpYear" @keyup.enter="changeData" placeholder="Nhập năm sinh" style="margin-left: 5px; width: 90%"/></td>
                </tr>
                <tr>
                  <td>Ngày sinh</td>
                  <td><input v-model="tmpDay" @keyup.enter="changeData" placeholder="Nhập ngày sinh" style="margin-left: 5px; width: 90%"/></td>
                </tr>
                <tr>
                  <td>Tháng sinh</td>
                  <td><input v-model="tmpMonth" @keyup.enter="changeData" placeholder="Nhập tháng sinh" style="margin-left: 5px; width: 90%"/></td>
                </tr>
                <tr>
                  <td>Giờ sinh</td>
                  <td>
                    <select v-model="tmpHour" @change="changeData" style="margin-left: 5px; width: 90%" @keyup.enter="changeData" >
                      <option
                        v-for="(value, index) in CHI"
                        :key="index"
                        :value="index + 1"
                      >
                        {{ value }} ({{ (index * 2 + 1 + 22) % 24}}h - {{ (index * 2 + 2 + 23) % 24}}h)
                      </option>
                    </select>
                  </td>
                </tr>
              </table>
            </td>
            <td class="p-3" style="border: 1px solid;">
              <table>
                <tr>
                  <td>
                    Xem Đại vận
                  </td>
                  <td class="pl-2">
                    <span class="text-small">
                      <input type="checkbox" name="tuhoadv" v-model="isShowTuHoaDv" @change="changeData">
                    </span>
                  </td>
                  <td>
                    <select v-model="tmpTuHoaDv" @change="changeData" style="margin-left: 5px; width: 90%" @keyup.enter="changeData" >
                      <option
                        v-for="(value, index) in optionDaiVan"
                        :key="index"
                        :selected="tmpTuHoaDv === value.cungSo"
                        :value="value.cungSo"
                      >
                        {{ value.name }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    Xem Tiểu vận
                  </td>
                  <td class="pl-2">
                    <span class="text-small">
                      <input type="checkbox" name="tuhoatv" v-model="isShowTuHoaTv" @change="changeData">
                    </span>
                  </td>
                  <td>
                    <select v-model="tmpTuHoaTv" @change="changeData" style="margin-left: 5px; width: 90%" @keyup.enter="changeData" >
                      <option
                        v-for="(value, index) in listTieuVan"
                        :key="index"
                        :selected="tmpTuHoaTv === (value.year + '_' + value.cungSo)"
                        :value="(value.year + '_' + value.cungSo)"
                      >
                        {{ value.year }} - {{ value.tuoi }}T
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    Tứ hoá cung phi
                  </td>
                  <td class="pl-2">
                    <span class="text-small">
                      <input type="checkbox" name="tuhoacp" v-model="isShowTuHoaCp" @change="changeData">
                    </span>
                  </td>
                  <td v-if="true">
                    <select v-model="typeChuyenTuHoa" @change="changeData" style="margin-left: 5px;width: 100%" @keyup.enter="changeData" >
                      <option
                        v-for="(value, index) in ['Lộc chuyển Kỵ', 'Kỵ chuyển Kỵ', 'Quyền chuyển Khoa', 'Khoa chuyển Khoa']"
                        :key="index"
                        :selected="typeChuyenTuHoa === index"
                        :value="index"
                      >
                        {{ value }}
                      </option>
                    </select>
                    <div class="text-small">
                      *Hiện tổng số tứ hoá
                      <span class="text-small">
                        <input type="checkbox" name="tuhoaout" v-model="isTuHoaIn" @change="changeData">
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    Đen trắng
                  </td>
                  <td class="pl-2">
                    <span class="text-small">
                      <input type="checkbox" name="modedentrang" v-model="isDenTrang" @change="changeData">
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    Ẩn/hiện sao
                  </td>
                  <td class="pl-2">
                    <span class="text-small">
                      <input type="checkbox" name="modeshowstart" v-model="isShowStar" @change="changeData">
                    </span>
                  </td>
                  <td>
                    <a-tree-select
                      v-model="showStar"
                      show-search
                      size="small"
                      style="width: 100%"
                      multiple
                      allow-clear
                      tree-checkable
                      :show-checked-strategy="TreeSelect.SHOW_PARENT"
                      :max-tag-count="1"
                      :tree-data="treeData"
                      treeNodeFilterProp="label"
                      class="ml-2 show-star"
                      @change="changeData"
                    />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="text-center mt-2">
          <button class="btn" type="submit" @click="changeData">Gửi</button>
        </div>
      </template>
    </section>
    <section>
      <div class="col-md-1 col-sm-1 col-xs-1 clearfix" style="width: 17%" />
      <div class="col-md-7 col-sm-7 col-xs-7 clearfix" style="min-width: 66%; margin: auto">
        <div class="box_content box_xvm box_ngaytotxau clearfix" style="border: none;">
          <div class="field">
            <div class="row">
              <div class="col-md-12">
                <div ref="printMe" id="printMe" style="display: none">
                  <div style="position: absolute;z-index: 10;width: 362px;margin: 260px 188px;height: 516px;">
                    <line-menh :cung-menh="cungMenh"/>
                  </div>
                  <div style="position: absolute;z-index: 100;width: 362px;margin: 260px 188px; height: 516px;">
                    <line-menh :cung-menh="diaBan.lineMenhPhu" :is-show-tu-hoa-tv="isShowTuHoaTv || isShowTuHoaDv"/>
                  </div>
                  <div
                    v-if="isShowTuHoaCp"
                    id="path" style="position: absolute;z-index: 1000;width: 100%;margin: 10px;height: 100%;">
                    <line-tu-hoa
                      v-for="(item, index) in pathTuHoa"
                      :key="index"
                      :index="index"
                      :path="item"
                      :first-color="initColor[0]"
                      :second-color="initColor[1]"
                      :style="`position: absolute; z-index: ${1000 + index + 1}`"
                    />
                  </div>
                  <div :class="isDenTrang ? 'lasotuvi dentrang' : 'lasotuvi'" id="lasotuvi">
                    <dia-ban
                      :thap-nhi-cung="thapNhiCung"
                      :thien-ban="thienBan"
                      :year="year"
                      :cur-year="curYear"
                      :is-show-tu-hoa-tv="isShowTuHoaTv"
                      :is-show-tu-hoa-dv="isShowTuHoaDv"
                      :is-show-tu-hoa-cp="isShowTuHoaCp"
                      :is-tu-hoa-in="isTuHoaIn"
                      :show-star="isShowStar ? showStar : []"
                    />
                  </div>
                </div>
                <div style="border: none; width: 100%; margin-bottom: 5%">
                  <img v-if="!isModeTyping && output" :src="output" style="margin: 3px;width: 100%;"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TuVi from '../mixins/TuVi'
export default {
  name: 'TuVi',
  mixins: [TuVi],
  methods: {
    async print () {
      const el = this.$refs.printMe
      const options = {
        logging: false,
        type: 'dataURL',
        onclone: (data) => {
          const hiddenDiv = data.getElementById('printMe')
          hiddenDiv.style.display = 'block'
          hiddenDiv.style.width = '738px'

          var svgElements = data.querySelectorAll('svg')
          svgElements.forEach(function (item) {
            item.setAttribute('width', 1000)
            item.setAttribute('height', 1000)
            item.style.width = null
            item.style.height = null
          })
        }
      }
      await this.$html2canvas(el, options).then((imgUrl) => {
        this.output = imgUrl
        this.isModeTyping = false
      })
    }
  }
}
</script>

<style scoped src="../assets/css/tuvi.css" />
<style scoped src="../assets/css/bootstrap.min.css" />

<style scoped>
  .text-small {
    font-weight: normal;
    font-size: 13px;
  }
</style>
<style>
  .ant-select-dropdown-menu-item {
    overflow: unset !important;
    text-overflow: unset !important;
  }
  .ant-select-not-found {
    text-align: center;
    margin-top: 5px;
  }
</style>
